"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9185],{

/***/ 79185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product_cards_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-desktop-component.scss.js


var StyledProductCardsGridDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1mr7i1q0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;justify-content:center;");

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./segments/desktop/constants.js
var constants = __webpack_require__(73759);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-card-grid-component/product-card-grid-component.scss.js





var CARD_BORDER_RADIUS = 8;
var CARD_BUTTON_BUTTON_STYLE = "\n  font-size: 0.8125rem;\n  white-space: nowrap;\n  min-width: unset;\n\n  * {\n    font-weight: 400;\n  }\n";
var StyledProductCardGridDekstopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e38tcc20"
})("width:286px;z-index:", z_index/* LAYER_ONE */.KW, ";margin:32px 10px 0;padding:32px 24px;border-radius:", "".concat(CARD_BORDER_RADIUS, "px"), ";background-color:white;", (0,constants.getComponentShadow)(), "  transition:filter 0.2s ease-in-out;color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";position:relative;&:hover,&.highlighted{", (0,constants.getComponentShadowWithHoverEffect)(), '}&.highlighted::before{content:"";position:absolute;top:0;left:0;right:0;bottom:0;border-radius:', "".concat(CARD_BORDER_RADIUS, "px"), ";padding:2px;background:var(--color);-webkit-mask:linear-gradient(#fff 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask-composite:exclude;pointer-events:none;}&.is-at-least-one-card-highlighted{margin:44px 10px 12px;padding:32px 24px;&.highlighted{margin:32px 2px 0;padding:44px 24px;}}.product-card-header{margin-bottom:32px;.product-card-header-image{height:51px;margin-bottom:5px;img{max-height:51px;}}.product-card-header-subtitle{color:", colors/* default.asphalt */.Z.asphalt, ";font-size:0.8125rem;line-height:1.125rem;}}.product-card-body{font-size:0.875rem;font-weight:300;line-height:1.5;}.product-card-divider{box-sizing:content-box;border-width:1px;border-style:solid;border-image:linear-gradient(to right,#ff158aff,#ff158a00);border-image-slice:1;margin-bottom:20px;margin-top:32px;}.product-card-use-cases{.product-card-use-cases-title{margin-bottom:12px;font-size:0.8125rem;}.product-card-use-cases-bullets{display:flex;margin-bottom:20px;flex-direction:column;.product-card-use-cases-bullet-icon-and-text{display:flex;margin-bottom:5px;font-size:0.8125rem;align-items:center;.product-card-use-cases-bullet-icon{display:flex;color:", colors/* default */.Z[color_consts.MARKETING_RED_COLOR_NAME], ";margin-right:5px;}}}}.product-card-footer{.signup-combo-buttons-button{display:flex;flex-direction:column;justify-content:center;.signup-button.ladda-button{", CARD_BUTTON_BUTTON_STYLE, "}}.signup-form-core-component-wrapper .signup-form{justify-content:flex-start;.signup-button{width:220px;margin-bottom:12px;", CARD_BUTTON_BUTTON_STYLE, "}}.secondary-button{font-size:0.8125rem;a{&.with-underline{background:unset;.secondary-button-text{color:", colors/* default.asphalt */.Z.asphalt, ";}}}*{font-weight:500;}}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 17 modules
var button_button = __webpack_require__(11068);
// EXTERNAL MODULE: ./node_modules/monday-ui-react-core/dist/icons/Check.js
var Check = __webpack_require__(74565);
var Check_default = /*#__PURE__*/__webpack_require__.n(Check);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-card-grid-component/product-card-grid-body-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var ProductCardGridBodyComponent = function(props) {
    var _useCases_list;
    var body = props.body, showDivider = props.showDivider, dividerStyle = props.dividerStyle, useCases = props.useCases, theme = props.theme, productCardButtonConfig = props.productCardButtonConfig;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-card-body",
                children: body === null || body === void 0 ? void 0 : body.bodyText
            }),
            showDivider && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-card-divider",
                style: dividerStyle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-card-use-cases",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-card-use-cases-title",
                        children: useCases === null || useCases === void 0 ? void 0 : useCases.text
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-card-use-cases-bullets",
                        children: useCases === null || useCases === void 0 ? void 0 : (_useCases_list = useCases.list) === null || _useCases_list === void 0 ? void 0 : _useCases_list.map(function(useCase, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "product-card-use-cases-bullet-icon-and-text",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-use-cases-bullet-icon",
                                        style: {
                                            color: colors/* default */.Z[theme]
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((Check_default()), {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "product-card-use-cases-bullet-text",
                                        children: useCase === null || useCase === void 0 ? void 0 : useCase.text
                                    })
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-card-footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, _object_spread({}, productCardButtonConfig))
            })
        ]
    });
};
/* harmony default export */ var product_card_grid_body_component = (ProductCardGridBodyComponent);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./constants/work-managment-logos.js
var work_managment_logos = __webpack_require__(74329);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/default-props.js








var _obj;
var productCardsImages = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_TYPE */.Ao, {
    url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
    image: {
        src: work_managment_logos/* default.WM_MAIN_LOGO */.Z.WM_MAIN_LOGO,
        alt: "monday work-management logo"
    },
    mobileImage: {
        src: work_managment_logos/* default.WM_MOBILE_1_LOGO */.Z.WM_MOBILE_1_LOGO,
        alt: "monday work-management logo"
    },
    mobileImageV2: {
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/local-mobile/WM-card-logo-v2.png",
        alt: "monday work-management logo"
    },
    mediumScreenImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/medium_size/wm_text.png",
        alt: "work management title"
    }
}), (0,src_define_property/* default */.Z)(_obj, products/* MARKETER_PRODUCT_TYPE */.wc, {
    url: links/* MARKETING_MANAGEMENT_MINI_SITE_LINK */.Txj,
    image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/marketer_main_logo.png",
        alt: "monday marketer logo"
    },
    mobileImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/Mobile/Marketer1.png",
        alt: "monday marketer logo"
    },
    mediumScreenImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/medium_size/marketer_text.png",
        alt: "monday marketer title"
    },
    mobileImageV2: {}
}), (0,src_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_TYPE */.Tp, {
    url: links/* CRM_MINI_SITE_LINK */.mgz,
    image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/crm_main_logo.png",
        alt: "monday CRM logo"
    },
    mobileImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/Mobile/Sales_CRM1.png",
        alt: "monday CRM logo"
    },
    mobileImageV2: {
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/local-mobile/CRM-card-logo-v2.png",
        alt: "monday CRM logo"
    },
    mediumScreenImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/medium_size/crm_text.png",
        alt: "monday sales title"
    }
}), (0,src_define_property/* default */.Z)(_obj, products/* PROJECTS_PRODUCT_TYPE */.ti, {
    url: links/* PROJECT_MANAGEMENT_MINI_SITE_LINK */.JgV,
    image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/projects_main_logo.png",
        alt: "monday projects logo"
    },
    mobileImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/Mobile/Project1.png",
        alt: "monday projects logo"
    },
    mediumScreenImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/medium_size/projects_text.png",
        alt: "monday projects title"
    },
    mobileImageV2: {}
}), (0,src_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_TYPE */.Ew, {
    url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
    image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/Dev_new_logo_July23/dev_main_logo1.png",
        alt: "monday dev logo"
    },
    mobileImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/Mobile/Dev1.png",
        alt: "monday dev logo"
    },
    mobileImageV2: {
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/local-mobile/DEV-card-logo-v2.png",
        alt: "monday dev logo"
    },
    mediumScreenImage: {
        src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/products/medium_size/dev_text.png",
        alt: "monday dev title"
    }
}), _obj);
var productIndexToProductType = {
    0: products/* WORK_MANAGEMENT_PRODUCT_TYPE */.Ao,
    1: products/* MARKETER_PRODUCT_TYPE */.wc,
    2: products/* CRM_PRODUCT_TYPE */.Tp,
    3: products/* PROJECTS_PRODUCT_TYPE */.ti,
    4: products/* DEV_PRODUCT_TYPE */.Ew
};
/* harmony default export */ var default_props = ({
    cards: [
        {
            showOpen: true,
            isHighlighted: false,
            productType: products/* WORK_MANAGEMENT_PRODUCT_TYPE */.Ao,
            theme: segments_service/* WORKOS_IRIS_THEME_ID */.M1,
            header: {
                subtitleText: "For professionals and teams managing tasks & workflows"
            },
            body: {
                bodyText: "Manage tasks, projects, and processes to fuel collaboration and efficiency at scale."
            },
            showDivider: true,
            useCases: {
                text: "Top use cases:",
                list: [
                    {
                        text: "Project management"
                    },
                    {
                        text: "Portfolio management"
                    },
                    {
                        text: "Resource management"
                    },
                    {
                        text: "Goals & strategy"
                    }
                ]
            },
            buttonConfig: {
                buttonType: button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae,
                buttonText: "Learn more",
                isOpenLinkInNewTab: true,
                color: color_consts.BRAND_BLACK_TEXT_COLOR,
                signupButtonConfig: {
                    buttonColor: color_consts.BRAND_BLACK_TEXT_COLOR,
                    signupProductId: products/* WORK_MANAGEMENT_PRODUCT_ID */.py
                },
                secondaryButtonConfig: {
                    buttonText: "Learn more",
                    url: links/* WORK_MANAGEMENT_MINI_SITE_LINK */.ler,
                    color: color_consts.BRAND_BLACK_TEXT_COLOR,
                    isOpenLinkInNewTab: true
                }
            }
        },
        {
            showOpen: false,
            isHighlighted: false,
            productType: products/* CRM_PRODUCT_TYPE */.Tp,
            theme: segments_service/* CRM_GREEN_THEME_ID */.wP,
            header: {
                subtitleText: "For sales professionals and customer-facing teams"
            },
            body: {
                bodyText: "Track and manage all aspects of your sales cycle, customer data, and more in one place."
            },
            showDivider: true,
            useCases: {
                text: "Top use cases:",
                list: [
                    {
                        text: "Contact management"
                    },
                    {
                        text: "Sales pipeline"
                    },
                    {
                        text: "Post-sales management"
                    },
                    {
                        text: "Lead management"
                    }
                ]
            },
            buttonConfig: {
                buttonType: button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae,
                buttonText: "Learn more",
                isOpenLinkInNewTab: true,
                color: color_consts.BRAND_BLACK_TEXT_COLOR,
                url: "https://monday.com/crm",
                signupButtonConfig: {
                    buttonColor: color_consts.BRAND_BLACK_TEXT_COLOR,
                    signupProductId: products/* CRM_PRODUCT_ID */.$,
                    signupClusterId: clusters.CRM
                },
                secondaryButtonConfig: {
                    buttonText: "Learn more",
                    url: links/* CRM_MINI_SITE_LINK */.mgz,
                    color: color_consts.BRAND_BLACK_TEXT_COLOR,
                    isOpenLinkInNewTab: true
                }
            }
        },
        {
            showOpen: false,
            isHighlighted: false,
            productType: products/* DEV_PRODUCT_TYPE */.Ew,
            theme: segments_service/* DEV_GREEN_THEME_ID */.xs,
            header: {
                subtitleText: "For product and development professionals and teams"
            },
            body: {
                bodyText: "Build agile workflows to drive impact across your product, design, and R&D teams."
            },
            showDivider: true,
            useCases: {
                text: "Top use cases:",
                list: [
                    {
                        text: "Roadmap planning"
                    },
                    {
                        text: "Scrum & Kanban"
                    },
                    {
                        text: "Bug tracking"
                    },
                    {
                        text: "Sprint dashboards"
                    }
                ]
            },
            buttonConfig: {
                buttonType: button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae,
                buttonText: "Learn more",
                isOpenLinkInNewTab: true,
                color: color_consts.BRAND_BLACK_TEXT_COLOR,
                url: "https://monday.com/dev",
                signupButtonConfig: {
                    buttonColor: color_consts.BRAND_BLACK_TEXT_COLOR,
                    signupProductId: products/* DEV_PRODUCT_ID */.xi,
                    signupClusterId: clusters.SOFTWARE
                },
                secondaryButtonConfig: {
                    buttonText: "Learn more",
                    url: links/* SOFTWARE_MINI_SITE_LINK */.DDD,
                    color: color_consts.BRAND_BLACK_TEXT_COLOR,
                    isOpenLinkInNewTab: true
                }
            }
        }
    ]
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-card-grid-component/product-card-grid-dekstop-component.js
function product_card_grid_dekstop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_card_grid_dekstop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_card_grid_dekstop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}










var ProductCardGridDekstopComponent = function(props) {
    var _productCardsImages_productType, _productCardsImages_productIndexToProductType_index, _productCardsImages_productType1;
    var isAtLeastOneCardHighlighted = props.isAtLeastOneCardHighlighted, isHighlighted = props.isHighlighted, header = props.header, body = props.body, showDivider = props.showDivider, useCases = props.useCases, buttonConfig = props.buttonConfig, index = props.index, productType = props.productType;
    var productTheme = productType ? products/* PRODUCTS_THEMES */._5[productType] : products/* PRODUCTS_THEMES */._5[productIndexToProductType[index]];
    var dividerStyle = {
        borderImageSource: "linear-gradient(to right, ".concat(colors/* default */.Z[productTheme], "ff, ").concat(colors/* default */.Z[productTheme], "00)")
    };
    var getProductButtonConfig = function() {
        switch(buttonConfig.buttonType){
            case button_consts/* SIGNUP_BUTTON_TYPE */.ge:
                return _object_spread_props(product_card_grid_dekstop_component_object_spread({}, buttonConfig), {
                    invert: true,
                    buttonSize: button_component.XS
                });
            case button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae:
                return _object_spread_props(product_card_grid_dekstop_component_object_spread({}, buttonConfig), {
                    signupButtonConfig: _object_spread_props(product_card_grid_dekstop_component_object_spread({}, buttonConfig.signupButtonConfig), {
                        invert: true,
                        buttonSize: button_component.XS
                    })
                });
            default:
                return buttonConfig;
        }
    };
    var productCardButtonConfig = getProductButtonConfig();
    var imageProp = productType ? productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productType = productCardsImages[productType]) === null || _productCardsImages_productType === void 0 ? void 0 : _productCardsImages_productType.image : productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productIndexToProductType_index = productCardsImages[productIndexToProductType[index]]) === null || _productCardsImages_productIndexToProductType_index === void 0 ? void 0 : _productCardsImages_productIndexToProductType_index.image;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductCardGridDekstopComponent, {
        className: classnames_default()("product-card", {
            highlighted: isHighlighted
        }, {
            "is-at-least-one-card-highlighted": isAtLeastOneCardHighlighted
        }),
        style: {
            "--color": "linear-gradient(0deg,".concat(colors/* default */.Z[productTheme], "ff,").concat(colors/* default */.Z[productTheme], "00)")
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "product-card-header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-card-header-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            tabIndex: "-1",
                            target: "_blank",
                            href: productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productType1 = productCardsImages[productType]) === null || _productCardsImages_productType1 === void 0 ? void 0 : _productCardsImages_productType1.url,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, product_card_grid_dekstop_component_object_spread({}, imageProp))
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "product-card-header-subtitle",
                        children: header === null || header === void 0 ? void 0 : header.subtitleText
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_grid_body_component, {
                    body: body,
                    showDivider: showDivider,
                    dividerStyle: dividerStyle,
                    useCases: useCases,
                    theme: productTheme,
                    productCardButtonConfig: productCardButtonConfig
                })
            })
        ]
    });
};
ProductCardGridDekstopComponent.defaultProps = {
    showDivider: true,
    buttonConfig: {
        buttonType: button_consts/* SECONDARY_BUTTON_TYPE */.jE,
        buttonText: "Learn more",
        isOpenLinkInNewTab: true
    }
};
/* harmony default export */ var product_card_grid_dekstop_component = (ProductCardGridDekstopComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-dekstop-component.js
function product_cards_grid_dekstop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_grid_dekstop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_grid_dekstop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function product_cards_grid_dekstop_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_cards_grid_dekstop_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_cards_grid_dekstop_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var ProductCardsGridDekstopComponent = function(props) {
    var _cards_map;
    var cards = props.cards;
    var isAtLeastOneCardHighlighted = cards === null || cards === void 0 ? void 0 : (_cards_map = cards.map(function(card) {
        return card === null || card === void 0 ? void 0 : card.isHighlighted;
    })) === null || _cards_map === void 0 ? void 0 : _cards_map.reduce(function(previousValue, currentValue) {
        return previousValue || currentValue;
    }, false);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductCardsGridDesktopComponent, {
        className: "product-cards-grid-desktop-component",
        children: cards === null || cards === void 0 ? void 0 : cards.filter(function(card) {
            return card.productType !== products/* MARKETER_PRODUCT_TYPE */.wc && card.productType !== products/* PROJECTS_PRODUCT_TYPE */.ti;
        }).map(function(card, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_grid_dekstop_component, product_cards_grid_dekstop_component_object_spread_props(product_cards_grid_dekstop_component_object_spread({}, card), {
                isAtLeastOneCardHighlighted: isAtLeastOneCardHighlighted
            }), index);
        })
    });
};
ProductCardsGridDekstopComponent.defaultProps = default_props;
/* harmony default export */ var product_cards_grid_dekstop_component = (ProductCardsGridDekstopComponent);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-mobile-component.scss.js


var StyledProductCardsGridMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evaz79q0"
})("max-width:", vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px;margin:auto;display:flex;justify-content:center;flex-direction:column;align-items:center;");

;// CONCATENATED MODULE: ./static/svg/small-down-arrow.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgSmallDownArrow = function SvgSmallDownArrow(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 6,
        fill: "none",
        viewBox: "0 0 10 6"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#323338",
        d: "M10 1.142 8.825 0 5 3.709 1.175 0 0 1.142 5 6z"
    })));
};
/* harmony default export */ var small_down_arrow = (SvgSmallDownArrow);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-card-grid-component/product-card-grid-mobile-component.scss.js




var product_card_grid_mobile_component_scss_CARD_BORDER_RADIUS = 8;
var StyledProductCardGridMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "enrgx5q0"
})("width:312px;height:auto;overflow:hidden;transition:max-height 0.2s ease-in-out;z-index:", z_index/* LAYER_ONE */.KW, ";margin:8px;padding:12px;border-radius:", "".concat(product_card_grid_mobile_component_scss_CARD_BORDER_RADIUS, "px"), ";background-color:", colors/* default */.Z[color_consts.WHITE_COLOR_NAME], ";box-shadow:0 8px 24px rgba(29,140,242,0.16);color:", colors/* default */.Z[color_consts.BRAND_BLACK_TEXT_COLOR], ";position:relative;.card-content{margin:8px;.product-card-header{margin-bottom:0;position:relative;display:flex;flex-direction:row;justify-content:space-between;.product-card-header-content{.product-card-header-image{height:unset;margin-bottom:unset;img{display:flex;max-height:26px;}&.is-v2{img{max-height:36px;}}}.product-card-header-text{font-size:0.75rem;color:", colors/* default.asphalt */.Z.asphalt, ";padding:12px 0 0 4px;}}.arrow{position:relative;transition:transform 0.2s ease-in-out;height:24px;&.open{transform:rotate(180deg);}}}.mobile-product-card-body{max-height:0px;transition:max-height 0.15s ease-out;overflow:hidden;.product-card-body{font-weight:300;line-height:1.5;font-size:0.875rem;margin-bottom:16px;margin-top:12px;}&.is-v2{.product-card-body{font-size:1.25rem;font-weight:600;line-height:1.3;}.product-card-use-cases .product-card-use-cases-bullets{margin-bottom:16px;.product-card-use-cases-bullet-icon-and-text{margin-bottom:8px;}}.product-card-footer{.button{.secondary-button{.secondary-button-text{font-size:0.8125rem;}}}}}.product-card-use-cases{overflow:hidden;.product-card-use-cases-title{margin-bottom:16px;font-size:0.8125rem;font-weight:500;}.product-card-use-cases-bullets{.product-card-use-cases-bullet-icon-and-text{display:flex;flex-direction:row;font-size:0.8125rem;margin-bottom:12px;gap:4px;align-items:center;.product-card-use-cases-bullet-icon{display:flex;}}}}.product-card-footer{.button{.signup-combo-buttons-button{display:flex;flex-direction:row;align-items:left;margin-top:12px;.signup-button{display:none;}.secondary-button-wrapper{margin-top:0px;font-size:0.281rem;margin-left:0px;.secondary-button{.secondary-button-text{font-size:0.8125rem;}}}}}}}}&.open{.card-content{.mobile-product-card-body{max-height:500px;transition:max-height 0.25s ease-in;}}}");

// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-card-grid-component/consts.js




var consts_obj;
var BUTTON_COLOR_BY_PRODUCT = (consts_obj = {}, (0,src_define_property/* default */.Z)(consts_obj, products/* WORK_MANAGEMENT_PRODUCT_TYPE */.Ao, color_consts.WORK_OS_IRIS_COLOR_NAME), (0,src_define_property/* default */.Z)(consts_obj, products/* CRM_PRODUCT_TYPE */.Tp, color_consts.CRM_DARKER_TINT_02_COLOR_NAME), (0,src_define_property/* default */.Z)(consts_obj, products/* DEV_PRODUCT_TYPE */.Ew, color_consts.DEV_DARKER_TINT_02_COLOR_NAME), consts_obj);
var _obj1;
var SIGNUP_ID_BY_PRODUCT = (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, products/* WORK_MANAGEMENT_PRODUCT_TYPE */.Ao, products/* WORK_MANAGEMENT_PRODUCT_ID */.py), (0,src_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_TYPE */.Tp, products/* CRM_PRODUCT_ID */.$), (0,src_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_TYPE */.Ew, products/* DEV_PRODUCT_ID */.xi), _obj1);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-card-grid-component/product-card-grid-mobile-component.js
function product_card_grid_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_card_grid_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_card_grid_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function product_card_grid_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_card_grid_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_card_grid_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}















var ProductCardGridMobileComponent = function(props) {
    var _productCardsImages_productIndexToProductType_index;
    var body = props.body, useCases = props.useCases, buttonConfig = props.buttonConfig, productType = props.productType, index = props.index, showOpen = props.showOpen, header = props.header, isV2 = props.isV2;
    var ref = (0,react.useState)(showOpen), isOpen = ref[0], setIsOpen = ref[1];
    var onCardHeaderClick = function() {
        if (!isOpen) {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.MOBILE_PRODUCT_COMPONENT_OPENED, {
                kind: productType,
                index: index
            });
        } else {
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.MOBILE_PRODUCT_COMPONENT_CLOSED, {
                kind: productType,
                index: index
            });
        }
        setIsOpen(!isOpen);
    };
    var getProductButtonConfig = function() {
        switch(buttonConfig.buttonType){
            case button_consts/* SIGNUP_BUTTON_TYPE */.ge:
                return product_card_grid_mobile_component_object_spread_props(product_card_grid_mobile_component_object_spread({}, buttonConfig), {
                    invert: isV2 ? false : true,
                    buttonSize: button_component/* XXS */.Mp,
                    buttonColor: isV2 && BUTTON_COLOR_BY_PRODUCT[productType],
                    signupProductId: isV2 && SIGNUP_ID_BY_PRODUCT[productType]
                });
            case button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae:
                return product_card_grid_mobile_component_object_spread_props(product_card_grid_mobile_component_object_spread({}, buttonConfig), {
                    signupButtonConfig: product_card_grid_mobile_component_object_spread_props(product_card_grid_mobile_component_object_spread({}, buttonConfig.signupButtonConfig), {
                        invert: true,
                        buttonSize: button_component/* XXS */.Mp
                    })
                });
            default:
                return buttonConfig;
        }
    };
    var getProductImage = function() {
        var _productCardsImages_productType, _productCardsImages_productType1;
        return isV2 ? productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productType = productCardsImages[productType]) === null || _productCardsImages_productType === void 0 ? void 0 : _productCardsImages_productType.mobileImageV2 : productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productType1 = productCardsImages[productType]) === null || _productCardsImages_productType1 === void 0 ? void 0 : _productCardsImages_productType1.mobileImage;
    };
    var productCardButtonConfig = getProductButtonConfig();
    var mobileImageProp = productType ? getProductImage() : productCardsImages === null || productCardsImages === void 0 ? void 0 : (_productCardsImages_productIndexToProductType_index = productCardsImages[productIndexToProductType[index]]) === null || _productCardsImages_productIndexToProductType_index === void 0 ? void 0 : _productCardsImages_productIndexToProductType_index.mobileImage;
    var productTheme = productType ? products/* PRODUCTS_THEMES */._5[productType] : products/* PRODUCTS_THEMES */._5[productIndexToProductType[index]];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductCardGridMobileComponent, {
        className: classnames_default()("mobile-product-card", {
            open: isOpen
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "card-content",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "product-card-header",
                    onClick: onCardHeaderClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "product-card-header-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("product-card-header-image", {
                                        "is-v2": isV2
                                    }),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, product_card_grid_mobile_component_object_spread({}, mobileImageProp))
                                }),
                                (header === null || header === void 0 ? void 0 : header.mobileSubTitleText) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "product-card-header-text",
                                    children: header === null || header === void 0 ? void 0 : header.mobileSubTitleText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("arrow", {
                                open: isOpen
                            }),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(small_down_arrow, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("mobile-product-card-body", {
                        "is-v2": isV2
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_card_grid_body_component, {
                        body: body,
                        showDivider: false,
                        useCases: useCases,
                        theme: productTheme,
                        productCardButtonConfig: productCardButtonConfig
                    })
                })
            ]
        })
    });
};
ProductCardGridMobileComponent.defaultProps = {
    showDivider: true,
    buttonConfig: {
        buttonType: button_consts/* SECONDARY_BUTTON_TYPE */.jE,
        buttonText: "Learn more",
        isOpenLinkInNewTab: true
    }
};
/* harmony default export */ var product_card_grid_mobile_component = (ProductCardGridMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-mobile-component.js
function product_cards_grid_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_grid_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_grid_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function product_cards_grid_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_cards_grid_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_cards_grid_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var ProductCardsGridMobileComponent = function(props) {
    var _props_cards;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledProductCardsGridMobileComponent, {
        className: "product-cards-grid-mobile-component",
        children: props === null || props === void 0 ? void 0 : (_props_cards = props.cards) === null || _props_cards === void 0 ? void 0 : _props_cards.filter(function(card) {
            return card.productType !== products/* MARKETER_PRODUCT_TYPE */.wc && card.productType !== products/* PROJECTS_PRODUCT_TYPE */.ti;
        }).map(function(card, index) {
            return /*#__PURE__*/ (0,react.createElement)(product_card_grid_mobile_component, product_cards_grid_mobile_component_object_spread_props(product_cards_grid_mobile_component_object_spread({}, card), {
                key: index,
                index: index
            }));
        })
    });
};
ProductCardsGridMobileComponent.defaultProps = default_props;
/* harmony default export */ var product_cards_grid_mobile_component = (ProductCardsGridMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-component.scss.js


var StyledProductCardsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e269rxk0"
})(".product-cards-grid-full-size-wrapper{display:unset;}.product-cards-grid-small-size-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.product-cards-grid-full-size-wrapper{display:none;}.product-cards-grid-small-size-wrapper{display:unset;}}");

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-component.js
function product_cards_grid_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_grid_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_grid_component_define_property(target, key, source[key]);
        });
    }
    return target;
}







var ProductCardsGridComponent = function(props) {
    var cards = props.cards;
    var productTypeMissing = function() {
        cards === null || cards === void 0 ? void 0 : cards.forEach(function(card, index) {
            var productType = card.productType;
            if (!productType) {
                esm_exports/* captureMessage */.uT("Product type is missing in card number: ".concat(index));
            }
        });
    };
    (0,react.useEffect)(function() {
        productTypeMissing();
    }, [
        cards
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledProductCardsGridComponent, {
        className: "product-cards-grid-component",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-cards-grid-full-size-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_cards_grid_dekstop_component, product_cards_grid_component_object_spread({}, props))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "product-cards-grid-small-size-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_cards_grid_mobile_component, product_cards_grid_component_object_spread({}, props))
            })
        ]
    });
};
ProductCardsGridComponent.defaultProps = default_props;
/* harmony default export */ var product_cards_grid_component = (ProductCardsGridComponent);


/***/ })

}]);